import { useSuspenseQuery } from '@apollo/client';
import React from 'react';

import { Card } from '../../../../components/Card/Card';
import { Icon } from '../../../../components/Icon/Icon';
import { KeyValueTable } from '../../../../components/KeyValueTable/KeyValueTable';
import { useModalPresenter } from '../../../../components/Modal/PresentedModal';
import { graphql } from '../../../../generated';
import { t } from '../../../../locales/translate';
import { Product } from '../../../../model/product';
import { withSuspendedCard } from '../../../../util/suspense';
import { formatDateTime } from '../../../../util/util';
import { EditBookChartsData } from '../Modals/edit_book_charts_data';

interface Props {
  product: Product;
}

const BOOK_CHARTS_DATA = graphql(`
  query Product($id: ID!) {
    product(id: $id) {
      id
      permissions {
        id
        updateBookChartsData
      }
      bookChartsData {
        id
        gtin
        description1
        description2
        productGroup
        releasedAt
      }
    }
  }
`);

export function BookCharts$({ product }: Props): JSX.Element {
  const { data } = useSuspenseQuery(BOOK_CHARTS_DATA, { variables: { id: product.id } });
  const modal = useModalPresenter();

  const updateBookChartsData =
    data.product?.__typename === 'MerchProduct' && data.product.permissions.updateBookChartsData;

  return (
    <Card
      title={t.model.bookCharts._name}
      actions={
        updateBookChartsData && (
          <Icon name="edit" onClick={() => modal.present(EditBookChartsData, { productId: product.id })} />
        )
      }
    >
      <KeyValueTable
        displayEmpty
        emptyMsg={t.model.product.noBookChart}
        labelWidth={200}
        items={[
          {
            key: t.model.bookCharts.productGroup,
            value: data.product?.bookChartsData?.productGroup,
          },
          {
            key: t.model.bookCharts.gtin,
            value: data.product?.bookChartsData?.gtin,
          },
          {
            key: t.model.bookCharts.description1,
            value: data.product?.bookChartsData?.description1,
          },
          {
            key: t.model.bookCharts.description2,
            value: data.product?.bookChartsData?.description2,
          },
          {
            key: t.model.bookCharts.releasedAt,
            value: formatDateTime(data.product?.bookChartsData?.releasedAt),
          },
        ]}
      ></KeyValueTable>
    </Card>
  );
}

export const BookCharts = withSuspendedCard(BookCharts$, { loadingTitle: t.model.bookCharts._name });
